import React, { useEffect } from "react";

import {
  getFecha,
  hosting,
  llamadasEntrantes,
  llamadasErrores,
  llamadasSalientes,
  mapStateToProps,
  mesArr,
} from "../funtComponents/models/buscar";
import Nav from "../funtComponents/nav";

import AlertTitle from "@mui/material/AlertTitle";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import LoadScreen from "../funtComponents/loadScreen";
import * as redux from "../../redux/constanst/index";
import { connect, useDispatch } from "react-redux";

//

import { Alert, Snackbar } from "@mui/material";

const Stacks = (props) => {
  const [openLoad, setOpenLoad] = React.useState(false);

  const dispatch = useDispatch();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    dispatch({ type: redux.USER_ERRORSTATE_STATE_CHANGE, errorState: [] });
    dispatch({ type: redux.USER_LOADERROR_STATE_CHANGE, loadError: false });
  };

  // ANEXOS

  const Check = async () => {
  
    const url = `${hosting}/mimegacall/api/tablero.php`;
    var formData = new FormData();
    formData.append("userId", props.idBuscar.id);
    const resp = await fetch(`${url}`, {
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      body: formData,
    }).then(async (data) => {
      const respBody = await data.json();

      dispatch({
        type: redux.USER_RIGHTANEXOS_STATE_CHANGE,
        rightAnexos: Object.values(respBody),
      });
    });

    return resp;
  };

  const handlerSearch = async (
    diaInicio,
    mesInicio,
    diaFinal,
    mesFinal,
    yearInicio,
    yearFinal,
    anexos
  ) => {
    const errores = llamadasErrores(
      "nada",
      0,
      diaInicio,
      mesInicio,
      diaFinal,
      mesFinal,
      yearInicio,
      yearFinal,
      anexos
    );
    if (typeof errores !== "number") {
      dispatch({
        type: redux.USER_ERRORSTATE_STATE_CHANGE,
        errorState: errores.mensaje,
      });
      dispatch({ type: redux.USER_LOADERROR_STATE_CHANGE, loadError: true });
    }
    if (errores === 200) {
      setOpenLoad(true);
      const respEntrantes = await llamadasEntrantes(
        "entrantes",
        0,
        diaInicio,
        mesInicio,
        diaFinal,
        mesFinal,
        yearInicio,
        yearFinal,
        anexos
      );
      const respSalientes = await llamadasSalientes(
        "salientes",
        0,
        diaInicio,
        mesInicio,
        diaFinal,
        mesFinal,
        yearInicio,
        yearFinal,
        anexos
      );
      if (respSalientes?.type === "SQL" || respEntrantes?.type === "SQL") {
        handlerSearch(
          diaInicio,
          mesInicio,
          diaFinal,
          mesFinal,
          yearInicio,
          yearFinal,
          anexos
        );
        return;
      }
      await dispatch({
        type: redux.USER_SALIENTES_STATE_CHANGE,
        salientes: respSalientes,
      });

      await dispatch({
        type: redux.USER_ENTRANTES_STATE_CHANGE,
        entrantes: respEntrantes,
      });
      setOpenLoad(false);
    }
  };

  const fetchDate = async (dateTime) => {
    let mesNumIni = 0;
    switch (dateTime.inicio.mes) {
      case "Enero":
        mesNumIni = 1;
        break;
      case "Febrero":
        mesNumIni = 2;
        break;
      case "Marzo":
        mesNumIni = 3;
        break;
      case "Abril":
        mesNumIni = 4;
        break;
      case "Mayo":
        mesNumIni = 5;
        break;
      case "Junio":
        mesNumIni = 6;
        break;
      case "Julio":
        mesNumIni = 7;
        break;
      case "Agosto":
        mesNumIni = 8;
        break;
      case "Septiembre":
        mesNumIni = 9;
        break;
      case "Octubre":
        mesNumIni = 10;
        break;
      case "Noviembre":
        mesNumIni = 11;
        break;
      case "Diciembre":
        mesNumIni = 12;
        break;
      default:
        break;
    }
    let mesNumFin = 0;
    switch (dateTime.final.mes) {
      case "Enero":
        mesNumFin = 1;
        break;
      case "Febrero":
        mesNumFin = 2;
        break;
      case "Marzo":
        mesNumFin = 3;
        break;
      case "Abril":
        mesNumFin = 4;
        break;
      case "Mayo":
        mesNumFin = 5;
        break;
      case "Junio":
        mesNumFin = 6;
        break;
      case "Julio":
        mesNumFin = 7;
        break;
      case "Agosto":
        mesNumFin = 8;
        break;
      case "Septiembre":
        mesNumFin = 9;
        break;
      case "Octubre":
        mesNumFin = 10;
        break;
      case "Noviembre":
        mesNumFin = 11;
        break;
      case "Diciembre":
        mesNumFin = 12;
        break;
      default:
        break;
    }

    dateTime.inicio.mes = mesNumIni;
    dateTime.inicio.dia = parseInt(dateTime.inicio.dia);
    dateTime.inicio.year = parseInt(dateTime.inicio.year);
    dateTime.final.mes = mesNumFin;
    dateTime.final.dia = parseInt(dateTime.final.dia);
    dateTime.final.year = parseInt(dateTime.final.year);

    dispatch({ type: redux.USER_DATEIN_STATE_CHANGE, dateIn: dateTime });

    dispatch({
      type: redux.USER_DATECHANGEINICIO_STATE_CHANGE,
      dateChangeInicio: dateTime.inicio,
    });
    dispatch({
      type: redux.USER_DATECHANGEFINAL_STATE_CHANGE,
      dateChangeFinal: dateTime.final,
    });
  };

  const drawerWidth = 240;
  //

  const fechaArray = getFecha();
  useEffect(() => {
    if (!props.fetchInit && Object.values(props.rightAnexos).length <= 0) {
      Check();
    }

    if (props.dateIn.length === 0) {
      fetchDate(dateTest);
    }
    if (!props.fetchInit && Object.values(props.rightAnexos).length > 0) {
      dispatch({ type: redux.USER_FECTHINIT_STATE_CHANGE, fetchInit: true });
      handlerSearch(
        props.dateChangeInicio.dia,
        props.dateChangeInicio.mes,
        props.dateChangeFinal.dia,
        props.dateChangeFinal.mes,
        props.dateChangeInicio.year,
        props.dateChangeFinal.year,
        Object.values(props.rightAnexos)
      );
      dispatch({ type: redux.USER_FECTHINIT_STATE_CHANGE, fetchInit: true });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const dateTest = {
    inicio: {
      dia: `${fechaArray[0][0]}`,
      mes: `${mesArr[fechaArray[0][1]]}`,
      year: `${fechaArray[0][2]}`,
    },
    final: {
      dia: `${fechaArray[1][0]}`,
      mes: `${mesArr[fechaArray[1][1]]}`,
      year: `${fechaArray[1][2]}`,
    },
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            width: `calc(100% - ${drawerWidth}px)`,
            ml: `${drawerWidth}px`,
          }}
        >
          <Nav />
        </AppBar>
        <Box
          component="main"
          sx={{
            width: `calc(100% - ${drawerWidth}px)`,
            ml: `${drawerWidth}px`,
            bgcolor: "background.default",
            p: 3,
          }}
        >
          <Toolbar />
          <Outlet />
          <Snackbar
            open={props.loadError}
            autoHideDuration={6000}
            onClose={handleClose}
            style={{ color: "white" }}
          >
            <Alert
              onClose={handleClose}
              variant="filled"
              severity="error"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Error</AlertTitle>
              {props.errorState}
            </Alert>
          </Snackbar>
          <LoadScreen setOpenLoad={setOpenLoad} openLoad={openLoad} />
        </Box>
      </Box>
    </>
  );
};

export default connect(mapStateToProps, null)(Stacks);
